import { css, styled } from '@mui/material';

import type { DropInsertLineProps } from './types';

/**
 * 드래그 앤 드롭 시 삽입 위치를 표시하는 라인 컴포넌트
 */
export function DropInsertLine({ visible, position }: DropInsertLineProps) {
  if (!visible) return null;
  return <InsertLine position={position} />;
}

const InsertLine = styled('div', {
  shouldForwardProp: prop => prop !== 'position',
})<{ position: 'top' | 'bottom' }>`
  position: absolute;
  left: 0px;
  right: 0px;
  height: 2px;
  background-color: ${({ theme }) => theme.color['actionSurface/primary/default']};
  z-index: ${({ theme }) => theme.zIndex.dragIndicator};

  ${({ position }) => css`
    ${position}: -1px;
  `}

  &::before {
    content: '';
    position: absolute;
    left: 0px;
    top: -3px;
    width: 0;
    height: 0;
    border-top: ${({ theme }) => theme.mixins.border('base/transparent', 4)};
    border-bottom: ${({ theme }) => theme.mixins.border('base/transparent', 4)};
    border-left: ${({ theme }) => theme.mixins.border('actionSurface/primary/default', 4)};
  }

  &::after {
    content: '';
    position: absolute;
    right: 0px;
    top: -3px;
    width: 0;
    height: 0;
    border-top: ${({ theme }) => theme.mixins.border('base/transparent', 4)};
    border-bottom: ${({ theme }) => theme.mixins.border('base/transparent', 4)};
    border-right: ${({ theme }) => theme.mixins.border('actionSurface/primary/default', 4)};
  }
`;
